"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickFreeModuleActivationSchema = void 0;
const baseSchema_1 = require("../baseSchema");
const baseClickSchema_1 = require("../baseSchema/baseClickSchema");
class ClickFreeModuleActivationSchema extends baseClickSchema_1.BaseClickSchema {
    constructor() {
        super({ componentName: 'FreeModuleModalActivationButton' });
        this.action = baseSchema_1.ActionsName.CLICK_FREE_MODULE_ACTIVATION;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            action: this.action
        };
    }
}
exports.ClickFreeModuleActivationSchema = ClickFreeModuleActivationSchema;
